module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABTklEQVQ4T53SPywEQRQG8Pft3R6lnLidoFJI0KhEq9EoNKhOo1FoVJijoLjdu0ojIhqJREEiUUk0aNGKRC2RmytORLc7O0/2/iSXI7nbnXLe+37JvHmgLifn6TMQT4DTa5UC3jrb0Q0Qnv/OhHEivlAyk48FjJR5VBv9UQ8x1VTBHowFOK6/ScBhIwSlZFr0DAwV/WkrhQdiGmiGXpS0Z3oChMuTDH1FRFOtAAjXFZle+gMITy8bEzYaLXxWZebU8YLX9nB9BMYcdIYtpJ7heMEdEc23ikra0R13+51m/RGO618SsJIEYOJjOCV9QszryQDkkfOCEoi2kwCh8Yej90oichMAT0rasxAlf4MZRwmAopL2HnKuXgX4PC4ADhcqhf7baIiLxHwTC2Cq+dbP2NdO9huiHMyxoft2QLjBFkeDBWX/24doqaq7fftR7Re9gZoUetUimgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/thumbsUp.png
// module id = UKXa
// module chunks = 1